
import React from 'react';
import styled from 'styled-components';
import Typography from '../../common/typography/Typography';

// Card container
const Card = styled.div`
  position: relative;
  width: 100%;


  margin:20px 0;
  background-color: #fff;
  border-radius: 16px;
  padding:20px;
  text-align: center;
  border: 2px solid #D6D5D9;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  @media (min-width: 768px) {
    margin:20px;
    ${({ highlighted }) =>
    highlighted &&
    `
      transform: scale(1.1);
  
      z-index: 1;
    `}
  }
  

  @media (max-width: 768px) {
    max-width: 90%; 
  }
`;

// Avatar wrapper for the image (to make it overlap with the card border)
const AvatarWrapper = styled.div`
  position: absolute;
  top: -10%;
  left: 5%;
  transform: translateY(-10%);
  width: 76px;
  height: 76px;
  background-color: #fff;
  border-radius: 50%;
  border: 2px solid #ddd; 
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  @media (max-width: 768px) {
     width: 56px;
     height: 56px;
  }
`;

const AvatarImage = styled.img`
  width: 76px;
  height: 76px;
  border-radius: 50%;
  object-fit: cover;
  @media (max-width: 768px) {
     width: 56px;
     height: 56px;
  }
`;

// Stars for the rating in the top right corner
const RatingWrapper = styled.div`
  position: absolute;
  top: 15px;
  right: 15px;
  display: flex;
`;

const Star = styled.span`
  color: #FFD700; /* Gold color for the stars */
  font-size: 16px;
  margin-left: 2px;
`;

// Paragraph in the middle of the card
const Paragraph = styled.p`
  margin: 30px 0 0;
`;

const UserInfo = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
`;

const UserName = styled.p`
  margin :5px;
`;

const UserRole = styled.p`
  margin :5px;
`;

const LikeIcon = styled.img`
  width: 100px;
  height: 20px;
`;

const CardComponent = ({ avatarUrl, rating, paragraph, highlighted, userName, userRole }) => {
  return (
    <Card highlighted={highlighted}>
      <AvatarWrapper>
        <AvatarImage src={avatarUrl} alt="Avatar" />
      </AvatarWrapper>

      <RatingWrapper>
        {Array(rating)
          .fill()
          .map((_, i) => (
            <Star key={i}><img src="./static/star.svg" alt="star" /></Star>
          ))}
      </RatingWrapper>
      <Paragraph>
          <Typography size="20px" weight="500px" >
        {paragraph}
      </Typography></Paragraph>
      <UserInfo>
        <div>
          <UserName>
            <Typography size="18px" weight="600px" >
              {userName}
            </Typography>

          </UserName>
          <UserRole>
            <Typography size="16px" weight="500px" >
              {userRole}
            </Typography>
          </UserRole>
        </div>
        <LikeIcon src="./static/testimonial.png" alt="like icon" />
      </UserInfo>
    </Card>
  );
};

// Container for the three cards
const TestimonialsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: flex-start;

  margin-top: 5px;

  @media (max-width: 768px) {
    flex-direction: column; 
     align-items: center;
  }
  @media (min-width: 600px) {
    padding-left: 56px;
    padding-right: 56px;
  }
  
`;

const Testimonials = () => {
  return (
    <TestimonialsContainer>
      <CardComponent
        avatarUrl="./static/avatar_1.png"
        rating={4}
        userName="Ronald Richards"
        userRole="Internal Implementation Officer"
        paragraph="Cras amet facilisis massa donec. Magna risus eget sed pharetra eu cras amet. Eget nec diam tristique ipsum porttitor. Scelerisque odio augue mi vel"
        highlighted={false}
      />
      <CardComponent
        avatarUrl="./static/avatar_2.png"
        rating={5}
        userName="Ronald Richards"
        userRole="Internal Implementation Officer"
        paragraph="Fusce non suspendisse facilisis odio. Est quam justo id at quam senectus vulputate. Vel nisl dapibus ut scelerisque sagittis pharetra euismod quis mi. Volutpat turpis amet mattis enim dictum lectus. Vulputate elit morbi volutpat donec."
        highlighted={true} // The middle card is highlighted
      />
      <CardComponent
        avatarUrl="./static/avatar_3.png"
        rating={3}
        userName="Ronald Richards"
        userRole="Internal Implementation Officer"
        paragraph="Cras amet facilisis massa donec. Magna risus eget sed pharetra eu cras amet. Eget nec diam tristique ipsum porttitor. Scelerisque odio augue mi vel"
        highlighted={false}
      />
    </TestimonialsContainer>
  );
};

export default Testimonials;
